import SEO from '@/components/SEO';
import ArticleRecommendation from '@/components/ArticleRecommendation';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { ArrowRight, Droplets, Leaf, Sparkles, Star, Plus, Truck, ShieldCheck, CreditCard, MessageCircle } from 'lucide-react';
import brandStoryHero from '@/assets/brand-story-hero-v2.jpg';
import productMainHero from '@/assets/product-main-hero.png.asset.json';
const trialPackProduct = productMainHero.url;
import summerIssuesDesktop from '@/assets/summer-issues-desktop.jpg';
import summerIssuesMobile from '@/assets/summer-issues-mobile.jpg';
import backCareJourney from '@/assets/back-care-journey.jpg';
import backCareJourneyMobile from '@/assets/back-care-journey-mobile.jpg';
import fiveIngredientsDesktop from '@/assets/five-ingredients-desktop.jpg';
import fiveIngredientsMobile from '@/assets/five-ingredients-mobile.jpg';
import threeSecDesktop from '@/assets/3sec-transform-desktop.jpg';
import threeSecMobile from '@/assets/3sec-transform-mobile.jpg';
import summerWearableDesktop from '@/assets/summer-wearable-desktop.jpg';
import summerWearableMobile from '@/assets/summer-wearable-mobile.jpg';
import trialPackDesktop from '@/assets/trial-pack-desktop.jpg';
import trialPackMobile from '@/assets/trial-pack-mobile.jpg';
import realFeedbackDesktop from '@/assets/real-feedback-desktop.jpg';
import realFeedbackMobile from '@/assets/real-feedback-mobile.jpg';
import probioticBalanceDesktop from '@/assets/probiotic-balance-desktop.jpg';
import probioticBalanceMobile from '@/assets/probiotic-balance-mobile.jpg';
import bundleOptionsDesktop from '@/assets/bundle-options-desktop-v4.png.asset.json';
import bundleOptionsMobile from '@/assets/bundle-options-mobile-v2.png.asset.json';

// 使用 public/preload 中的固定路徑，與 index.html 的 <link rel="preload"> 完全一致，避免 Vite hash 造成預載失效
import heroDesktopAsset from '@/assets/hero-desktop-v5.jpg.asset.json';
import heroMobileAsset from '@/assets/hero-mobile-v5.jpg.asset.json';
const heroDesktop = heroDesktopAsset.url;
const heroTablet = heroDesktopAsset.url;
const heroMobile = heroMobileAsset.url;

import productFig from '@/assets/product-fig.png';
const cartProduct = productMainHero.url;
import productShowcase from '@/assets/images/product-showcase.jpg';
import Layout from '@/components/layout/Layout';

import dmVideo1Asset from '@/assets/dm-video-1.mp4.asset.json';
import dmVideo2Asset from '@/assets/dm-video-2.mp4.asset.json';
import dmImage3 from '@/assets/dm-image-3.jpg';
import dmImage4 from '@/assets/dm-image-4.jpg';
import dmImage5 from '@/assets/dm-image-5.jpg';
import dmVideo6Asset from '@/assets/dm-video-6.mp4.asset.json';
import dmImage7 from '@/assets/dm-image-7.jpg';
import dmImage8 from '@/assets/dm-image-8.jpg';
import homeVideoPoster1 from '@/assets/home-videos/v1.jpg';
import homeVideoPoster2 from '@/assets/home-videos/v2.jpg';
import homeVideoPoster3 from '@/assets/home-videos/v3.jpg';
import homeVideoPoster4 from '@/assets/home-videos/v4.jpg';
import homeVideo1Asset from '../../public/home-videos/v1.mp4.asset.json';
import homeVideo2Asset from '../../public/home-videos/v2.mp4.asset.json';
import homeVideo3Asset from '../../public/home-videos/v3.mp4.asset.json';
import homeVideo4Asset from '../../public/home-videos/v4.mp4.asset.json';
const dmVideo1 = dmVideo1Asset.url;
const dmVideo2 = dmVideo2Asset.url;
const dmVideo6 = dmVideo6Asset.url;
import DmVideoItem from '@/components/DmVideoItem';
import Testimonials from '@/components/Testimonials';
import KocReviews from '@/components/KocReviews';
import PromoPopup from '@/components/PromoPopup';
import { useCart } from '@/contexts/CartContext';

const Index = () => {
  const { addItem } = useCart();

  const handleAddToCart = () => {
    addItem({
      id: 'satin-probiotic-bath-oil-trial',
      name: '絲緞益菌平衡沐浴油霜',
      nameEn: 'Satin Probiotic Balance Bath Oil Cream',
      price: 990,
      size: '嚐鮮單入組',
      image: cartProduct,
      sku: 'BUNDLE-VRFC-01'
    });
  };
  return <Layout>
      <PromoPopup />
      <SEO title="Velireo Skin — 益菌微生態護膚專家｜溫和沐浴油霜" description="Velireo Skin 以益生菌後生元科技打造微生態護膚。絲緞益菌平衡沐浴油霜，結合8重玻尿酸與天然植萃，溫和清潔同時修護肌膚屏障。立即選購享優惠。" ogImage="https://velireoskin.com/assets/product-detail-main.jpg" canonical="https://velireoskin.com/" />
      <Helmet>
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "Velireo Skin",
          "url": "https://velireoskin.com",
          "description": "微生態護膚品牌，以益生菌後生元科技守護肌膚天然屏障",
          "logo": "https://velireoskin.com/favicon.ico",
          "brand": { "@type": "Brand", "name": "Velireo Skin" },
          "sameAs": ["https://lin.ee/4WzcOt7"]
        })}</script>
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": "Velireo Skin",
          "url": "https://velireoskin.com"
        })}</script>
        {/* Hero LCP image preload moved to index.html static <head> */}
      </Helmet>
      <h1 className="sr-only">Velireo Skin — 益菌微生態護膚專家｜絲緞益菌平衡沐浴油霜</h1>
      {/* Hero Section */}
      <section className="relative overflow-hidden bg-background">
        {/* 響應式主視覺：依裝置自動切換三張圖，點擊進入產品頁 */}
        <Link to="/product-details" aria-label="查看 Velireo Skin 絲緞益菌平衡沐浴油霜產品詳情" className="block">
          <picture>
            <source media="(min-width: 1024px)" srcSet={heroDesktop} width={1672} height={941} />
            <source media="(min-width: 768px)" srcSet={heroTablet} width={1672} height={941} />
            <img
              src={heroMobile}
              alt="Velireo Skin 絲緞益菌平衡沐浴油霜 產品形象照"
              width={1086}
              height={1448}
              fetchPriority="high"
              className="block w-full h-auto cursor-pointer"
            />
          </picture>
        </Link>
      </section>


      {/* Hero 下方三大賣點 — 整塊立體卡片，三欄置中（緊貼 hero） */}
      <section className="bg-background">
        <div className="container mx-auto px-4 lg:px-8 pt-3 lg:pt-4 pb-10 lg:pb-14">
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="max-w-6xl mx-auto bg-background rounded-2xl border border-border/40 shadow-soft hover:shadow-elevated transition-shadow duration-300"
          >
            <div className="grid grid-cols-1 md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-border/50">
              {[{
                icon: Sparkles,
                title: '專利益菌養膚科技',
                description: '維持肌膚油水平衡，各膚質適用'
              }, {
                icon: Leaf,
                title: '5 種植物油',
                description: '溫和卸除防曬與髒污，皮膚不乾癢'
              }, {
                icon: Droplets,
                title: '8 重玻尿酸',
                description: '多分子從外鎖到內，補水不留死角'
              }].map((item) => (
                <div
                  key={item.title}
                  className="flex items-center justify-center gap-4 md:gap-5 px-6 py-6 md:py-7"
                >
                  <div className="shrink-0 w-12 h-12 md:w-14 md:h-14 rounded-full border border-primary flex items-center justify-center">
                    <item.icon className="h-5 w-5 md:h-6 md:w-6 text-primary" strokeWidth={1.5} />
                  </div>
                  <div className="min-w-0">
                    <h2 className="font-serif-tc text-[18px] md:text-[20px] font-normal mb-1 text-foreground leading-snug">
                      {item.title}
                    </h2>
                    <p className="font-sans-tc text-[13px] md:text-sm text-muted-foreground leading-relaxed">
                      {item.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </section>




      {/* 夏天背痘、出油、顆粒嚴重？— 整段一張大圖（手機/桌機分版） */}
      <motion.section
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        viewport={{ once: true, amount: 0.2 }}
        className="bg-background border-t border-border/40"
      >
        <picture>
          <source media="(min-width: 768px)" srcSet={summerIssuesDesktop} />
          <img
            src={summerIssuesMobile}
            alt="夏天背痘、出油、顆粒嚴重？3 分鐘把清潔變成身體肌保養 — 6 大常見肌膚困擾"
            loading="lazy"
            className="block w-full h-auto"
          />
        </picture>
      </motion.section>

      {/* 背痘故事大圖 — 銜接困擾區（手機/桌機分版） */}
      <motion.section
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        viewport={{ once: true, amount: 0.2 }}
        className="bg-background"
      >
        <picture>
          <source media="(min-width: 768px)" srcSet={backCareJourney} />
          <img
            src={backCareJourneyMobile}
            alt="Velireo Skin 背痘照護旅程 — 不是不敢穿，是背痘讓妳不想被看見"
            loading="lazy"
            className="block w-full h-auto"
          />
        </picture>
      </motion.section>

      {/* Velireo 益菌平衡比較圖（手機/桌機分版） */}
      <motion.section
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        viewport={{ once: true, amount: 0.2 }}
        className="bg-background"
      >
        <picture>
          <source media="(min-width: 768px)" srcSet={probioticBalanceDesktop} />
          <img
            src={probioticBalanceMobile}
            alt="Velireo Skin 沐浴油霜 vs 一般抗痘清潔 vs 酸類皂鹼產品 — 從肌膚好菌平衡開始，讓肌膚穩定下來"
            loading="lazy"
            className="block w-full h-auto"
          />
        </picture>
      </motion.section>


      {/* 5 大核心成分賣點圖（手機/桌機分版） */}
      <motion.section
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        viewport={{ once: true, amount: 0.2 }}
        className="bg-background"
      >
        <picture>
          <source media="(min-width: 768px)" srcSet={fiveIngredientsDesktop} />
          <img
            src={fiveIngredientsMobile}
            alt="Velireo Skin 絲緞益菌平衡沐浴油霜 5 大核心成分 — 益菌養膚科技、5 種植物油、8 重玻尿酸、pH 5.5 弱酸、絲緞油霜質地"
            loading="lazy"
            className="block w-full h-auto"
          />
        </picture>
      </motion.section>

      {/* 3 秒乳化展示（手機/桌機分版） */}
      <motion.section
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        viewport={{ once: true, amount: 0.2 }}
        className="bg-background"
      >
        <picture>
          <source media="(min-width: 768px)" srcSet={threeSecDesktop} />
          <img
            src={threeSecMobile}
            alt="Velireo Skin 絲緞益菌平衡沐浴油霜 — 3 秒從深玫瑰粉油霜變成柔白乳泡"
            loading="lazy"
            className="block w-full h-auto"
          />
        </picture>
      </motion.section>

      {/* 這個夏天可以真的穿出門（手機/桌機分版） */}
      <motion.section
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        viewport={{ once: true, amount: 0.2 }}
        className="bg-background"
      >
        <picture>
          <source media="(min-width: 768px)" srcSet={summerWearableDesktop} />
          <img
            src={summerWearableMobile}
            alt="Velireo Skin 絲緞益菌平衡沐浴油霜 — 這個夏天，背心、細肩帶、泳衣可以真的穿出門"
            loading="lazy"
            className="block w-full h-auto"
          />
        </picture>
      </motion.section>

      {/* 體驗包零風險試用（手機/桌機分版） */}
      <motion.section
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        viewport={{ once: true, amount: 0.2 }}
        className="bg-background"
      >
        <picture>
          <source media="(min-width: 768px)" srcSet={trialPackDesktop} />
          <img
            src={trialPackMobile}
            alt="Velireo Skin 絲緞益菌平衡沐浴油霜 — 不用急著開正裝，先用 3 包體驗包感受看看，不滿意可無條件退回正裝"
            loading="lazy"
            className="block w-full h-auto"
          />
        </picture>
      </motion.section>

      {/* 真實回饋與膚質檢測（手機/桌機分版） */}
      <motion.section
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        viewport={{ once: true, amount: 0.2 }}
        className="bg-background"
      >
        <picture>
          <source media="(min-width: 768px)" srcSet={realFeedbackDesktop} />
          <img
            src={realFeedbackMobile}
            alt="Velireo Skin 絲緞益菌平衡沐浴油霜 — 真實使用回饋：背痘改善、膚質檢測 2 週水分油分彈性白皙度變化"
            loading="lazy"
            className="block w-full h-auto"
          />
        </picture>
      </motion.section>




      {/* 短影音精選 — 主背景區 */}
      <section aria-label="Velireo Skin 短影音精選" className="bg-background py-12 md:py-16">
        <div className="container mx-auto px-4 lg:px-8 max-w-6xl">
          <h2 className="font-serif-tc text-[26px] lg:text-[34px] font-light tracking-wide text-center mb-3 text-brand-charcoal">
            來自真實生活的洗澡實驗
          </h2>
          <div className="w-12 h-px bg-brand-rose mx-auto mb-10" />
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-5">
            {[
              { src: homeVideo1Asset.url, poster: homeVideoPoster1, label: '你見過用顏料洗澡嗎？' },
              { src: homeVideo2Asset.url, poster: homeVideoPoster2, label: '油霜質地是什麼黑科技？' },
              { src: homeVideo3Asset.url, poster: homeVideoPoster3, label: '泡泡越多越乾淨是騙局' },
              { src: homeVideo4Asset.url, poster: homeVideoPoster4, label: '直男抗拒不了的高級偽體香' },
            ].map((v) => (
              <div key={v.src} className="relative block w-full aspect-[9/16] rounded-xl shadow-soft overflow-hidden bg-black group cursor-pointer"
                onClick={(e) => {
                  const container = e.currentTarget;
                  if (container.dataset.playing === 'true') return;
                  const video = container.querySelector('video') as HTMLVideoElement;
                  const img = container.querySelector('img') as HTMLImageElement;
                  const overlay = container.querySelector('[data-play-overlay]') as HTMLDivElement;
                  if (video) {
                    container.dataset.playing = 'true';
                    img.style.opacity = '0';
                    if (overlay) overlay.style.opacity = '0';
                    video.style.opacity = '1';
                    video.style.zIndex = '30';
                    video.play();
                  }
                }}
              >
                {/* Poster image as cover */}
                <img
                  src={v.poster}
                  alt={v.label}
                  loading="eager"
                  className="absolute inset-0 w-full h-full object-cover z-10 transition-opacity duration-300"
                />
                {/* Play button overlay */}
                <div data-play-overlay className="absolute inset-0 z-20 flex items-center justify-center pointer-events-none transition-opacity duration-300">
                  <div className="w-12 h-12 rounded-full bg-white/80 flex items-center justify-center shadow-md group-hover:scale-110 transition-transform duration-300">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" className="text-brand-charcoal ml-1">
                      <path d="M8 5v14l11-7z" />
                    </svg>
                  </div>
                </div>
                {/* Video hidden until clicked */}
                <video
                  src={v.src}
                  controls
                  playsInline
                  preload="none"
                  className="absolute inset-0 w-full h-full object-cover opacity-0 z-0"
                  aria-label={v.label}
                  onEnded={(e) => {
                    const video = e.currentTarget as HTMLVideoElement;
                    const container = video.parentElement as HTMLDivElement;
                    const img = container?.querySelector('img') as HTMLImageElement;
                    const overlay = container?.querySelector('[data-play-overlay]') as HTMLDivElement;
                    video.style.opacity = '0';
                    video.style.zIndex = '0';
                    if (img) img.style.opacity = '1';
                    if (overlay) overlay.style.opacity = '1';
                    if (container) container.dataset.playing = 'false';
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* KOC 真實體驗 — 社會證明 */}
      <KocReviews />












      {/* 三入口卡片：CTA 橫幅 + 品牌故事 / 好評見證 / 常見問題 + 信任徽章 */}
      <section aria-label="品牌入口" className="bg-background py-16 md:py-20">
        <div className="container mx-auto px-4 lg:px-8 max-w-6xl">
          {/* B. 三入口卡片 */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            viewport={{ once: true, amount: 0.15 }}
            className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6"
          >
            {/* 品牌故事 */}
            <Link
              to="/brand-story"
              className="group bg-brand-sand rounded-2xl shadow-sm hover:shadow-md transition-shadow p-8 min-h-[280px] flex flex-col"
            >
              <h3 className="font-serif-tc text-2xl text-foreground mb-5 tracking-wide">品牌故事</h3>
              <p className="font-sans-tc text-sm leading-loose text-muted-foreground flex-1">
                Velireo 源自拉丁語，意為「真實．純粹」。我們相信，純粹的成分與真誠的保養，能讓肌膚回到最美好狀態。
              </p>
              <span className="mt-6 inline-flex items-center gap-1 text-sm text-brand-rose group-hover:gap-2 transition-all">
                探索 Velireo 品牌故事 <ArrowRight className="w-4 h-4" />
              </span>
            </Link>

            {/* 好評見證 */}
            <a
              href="#testimonials-heading"
              className="group bg-brand-sand rounded-2xl shadow-sm hover:shadow-md transition-shadow p-8 min-h-[280px] flex flex-col"
            >
              <h3 className="font-serif-tc text-2xl text-foreground mb-5 tracking-wide">好評見證</h3>
              <div className="flex-1 flex flex-col items-center justify-center text-center relative">
                <span className="font-serif-en text-5xl text-brand-rose/30 leading-none absolute -left-1 -top-2" aria-hidden="true">“</span>
                <span className="font-serif-en text-5xl text-brand-rose/30 leading-none absolute -right-1 bottom-6" aria-hidden="true">”</span>
                <p className="font-sans-tc text-sm leading-loose text-muted-foreground px-4">
                  質地很滋潤但不黏膩，<br />
                  敏感肌使用也很安心，<br />
                  肌膚變得柔嫩有光澤！
                </p>
                <div className="flex gap-0.5 mt-4 text-brand-rose">
                  {[0,1,2,3,4].map(i => <Star key={i} className="w-4 h-4 fill-current" />)}
                </div>
                <p className="font-sans-tc text-xs text-muted-foreground mt-3">— 林小姐，乾性肌膚</p>
              </div>
            </a>

            {/* 常見問題 → 智能客服 */}
            <Link
              to="/product-details#faq"
              className="group bg-brand-sand rounded-2xl shadow-sm hover:shadow-md transition-shadow p-8 min-h-[280px] flex flex-col"
            >
              <h3 className="font-serif-tc text-2xl text-foreground mb-5 tracking-wide">常見問題</h3>
              <ul className="list-divided flex-1 text-sm font-sans-tc text-muted-foreground">
                {[
                  '產品適合敏感肌嗎？',
                  '孕婦可以使用嗎？',
                  '多久可以看到效果？',
                  '如何搭配使用效果更好？',
                ].map((q) => (
                  <li key={q} className="flex items-center justify-between gap-2">
                    <span>{q}</span>
                    <Plus className="w-4 h-4 text-muted-foreground shrink-0" />
                  </li>
                ))}
              </ul>
              <span className="mt-5 inline-flex items-center gap-1 text-sm text-brand-rose group-hover:gap-2 transition-all">
                查看全部 FAQ <ArrowRight className="w-4 h-4" />
              </span>
            </Link>
          </motion.div>

          {/* C. 信任徽章 4 欄 */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
            viewport={{ once: true, amount: 0.2 }}
            className="mt-8 md:mt-10 bg-brand-sand rounded-2xl px-4 md:px-8 py-5 md:py-6 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6"
          >
            {[
              { icon: Truck, title: '運費透明', desc: '7-11 NT$65・宅配 NT$100' },
              { icon: ShieldCheck, title: '0 風險試用', desc: '不滿意無條件退費' },
              { icon: CreditCard, title: '安心付款', desc: '信用卡・ATM・超商' },
              { icon: MessageCircle, title: '官方 LINE', desc: '24 小時即時客服' },
            ].map((item) => (
              <div key={item.title} className="flex items-center gap-3">
                <div className="shrink-0 w-10 h-10 rounded-full border border-brand-rose/40 flex items-center justify-center">
                  <item.icon className="w-4 h-4 md:w-5 md:h-5 text-brand-rose" strokeWidth={1.5} />
                </div>
                <div className="min-w-0">
                  <p className="font-sans-tc text-sm text-foreground leading-tight mb-0.5">{item.title}</p>
                  <p className="font-sans-tc text-xs text-muted-foreground leading-tight">{item.desc}</p>
                </div>
              </div>
            ))}
          </motion.div>
        </div>
      </section>


      {/* 延伸閱讀 — 整區淡入 */}
      <motion.div
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        viewport={{ once: true, amount: 0.15 }}
      >
        <ArticleRecommendation
          title="保養知識"
          subtitle="了解更多益菌護膚的科學與日常保養秘訣"
          count={3}
          slugs={(() => {
            const latest5 = ['skin-microbiome-guide', 'probiotic-skincare-guide', 'seasonal-skincare-strategy-2026', 'shower-cream-oil-texture-guide', 'velireo-skin-brand-story'];
            return [...latest5].sort(() => Math.random() - 0.5).slice(0, 3);
          })()}
        />
      </motion.div>

    </Layout>;
};
export default Index;